import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=621b1c72&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=621b1c72&prod&lang=scss&scoped=true"
import style1 from "./TodoList.vue?vue&type=style&index=1&id=621b1c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b1c72",
  null
  
)

export default component.exports